import script from "./MyTasksSection.vue?vue&type=script&setup=true&lang=js"
export * from "./MyTasksSection.vue?vue&type=script&setup=true&lang=js"

import "./MyTasksSection.vue?vue&type=style&index=0&id=1b2d5662&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b2d5662"]])

export default __exports__